// RSI指标计算
// LC = REF(CLOSE, 1)
// RSI1 = SMA(MAX(CLOSE - LC, 0), N1, 1) / SMA(ABS(CLOSE - LC), N1, 1) * 100
// RSI2 = SMA(MAX(CLOSE - LC, 0), N2, 1) / SMA(ABS(CLOSE - LC), N2, 1) * 100
// RSI3 = SMA(MAX(CLOSE - LC, 0), N3, 1) / SMA(ABS(CLOSE - LC), N3, 1) * 100
import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
const model = {
    // 收盘价
    // 昨日收盘价
    rsi6: {
        Type: Array,
        Default: () => ([])
    },
    rsi12: {
        Type: Array,
        Default: () => ([])
    },
    rsi24: {
        Type: Array,
        Default: () => ([])
    },
    params: {
        type: String,
        Default: 'RSI(6,12,24)'
    }
    // 天数
};
export default class RSIState extends FootDectorator(BaseContext) {
    constructor({ data, ...rest }) {
        super({ ...rest, data: mergeModelData(model, data) })

    }
    // 计算y轴
    _calcRange() {
        let { rsi6, rsi12, rsi24, code, params } = this.state.data;
        let { maxValue, minValue } = this.calcRange({ data: [rsi6, rsi12, rsi24], targetKey: 'value', isAdditional: true })
        this.maxValue = maxValue;
        this.minValue = minValue;
    };
    // 计算坐标
    _calcAxis() {
        const maxValue = this.maxValue;
        const range = maxValue * 2;
        const { height
        } = this.availArea;
        const ratio = height / range;
        const { rsi6, rsi12, rsi24 } = this.state.data;
        const curryCalcAxis = curryFun(this.calcAxis, this, {
            targetKey: 'value',
            sourceKey: 'lineY',
            isAdditional: true,
        });
        curryCalcAxis({ data: rsi6 });
        curryCalcAxis({ data: rsi12 });
        curryCalcAxis({ data: rsi24 })
    };
    // 画主图
    _drawMain() {
      const {
        left,
        bottom,
        width
      } = this.availArea;
      const { rsi6, rsi12, rsi24 } = this.state.data;
      const { LINE } = LINE_TYPE;
      const { rsi6: Rsi6, rsi12: Rsi12, rsi24: Rsi24 } = this.option.Rsi;
      this._drawLine(LINE, rsi6, left, bottom, Rsi6.lineWidth, Rsi6.color);
      this._drawLine(LINE, rsi12, left, bottom, Rsi12.lineWidth, Rsi12.color);
      this._drawLine(LINE, rsi24, left, bottom, Rsi24.lineWidth, Rsi24.color);
    };
    // 画y轴的数值
    _drawAxisY() {
        const { axisY } = this.option.Rsi;
        const {
            left,
            right,
            top,
            bottom,
            height
        } = this.availArea;
      const maxValue = this.maxValue;
      const minValue = this.minValue;
      // const line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
      let line;
      if(maxValue>0&&minValue<0){
        line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
      }else if(maxValue<0&&minValue<0) {
        line=((Math.abs(minValue)-Math.abs(maxValue))/2+minValue).toFixed(2)
      }else {
        line=((Math.abs(maxValue)-Math.abs(minValue))/2+minValue).toFixed(2)
      }
      const ctx = this.context;
      ctx.beginPath();
      const { sizeRatio, fontFamily, color } = this.option.Rsi.axisY;
      ctx.font = sizeRatio * this.state.baseSize * this.dpr + 'px ' + fontFamily;
      ctx.strokeStyle = color;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillText(maxValue.toFixed(2), left, top+20);
      ctx.textBaseline = 'middle';
      ctx.fillText(line, left, top + height / 2);
      ctx.textBaseline = 'bottom';
      ctx.fillText(minValue.toFixed(2), left, bottom);
    };
    // @checkFootTitleAuth
    // 画左上角的title
    _drawTitle() {
        const ctx2 = this.curContext;
        const { top } = this.availArea;
        const { current, sealObj } = this.state.data;
        const { height, baseSize } = this.state;
        const { ratioFixed } = sealObj;
        const { space } = this.option.Rsi
        const { baseLine } = this.option.FootContext.title;
        const baseLineY = top + height * baseLine;
        let { left } = this.availArea;
        // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
        const {
            sizeRatio,
            fontFamily,
            axisY,
        } = this.option.Rsi;
        [
            'params',
            'rsi6',
            'rsi12',
            'rsi24',
        ].forEach(val => {
            const data = this.state.data[val];
            if (data == 'RSI(6,12,24)') {
                let color = this.option.Rsi.params.color
                ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                ctx2.fillStyle = color;
                ctx2.textAlign = 'left';
                ctx2.textBaseline = 'top';
                ctx2.beginPath();
                const text = data
                const textWidth = ctx2.measureText(text).width;
                ctx2.fillText(text, left, baseLineY);
                left += textWidth+10;
            } else {
                if (Util.isArray(data)) {
                    let color = this.option.Rsi[val].color
                    const item = data[current]
                    ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                    ctx2.fillStyle = color;
                    ctx2.textAlign = 'left';
                    ctx2.textBaseline = 'top';
                    ctx2.beginPath();
                    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
                        const text = val.toUpperCase() + ': ' + item.value.toFixed(ratioFixed);
                        // 返回包含指定文本宽度的对象
                        const textWidth = ctx2.measureText(text).width;
                        // 	在画布上绘制“被填充的”文本  text是填充的内容 left为x坐标  ，baseLinY为y坐标
                        ctx2.fillText(text, left, baseLineY);
                        left += textWidth;

                    } else {
                        const text = val.toUpperCase() + ': -';

                        const textWidth = ctx2.measureText(text).width;
                        ctx2.fillText(text, left, baseLineY);
                        left += textWidth;
                    }
                    left += space * this.dpr;

                }
            }
        })
    };
}
